<template lang="pug">
filter-detail-container(
  :title="title"
  @back="back"
  @save="save"
)
  template(v-slot:body)
    .pa-6
      template(v-if="filter.datatype === 'string'")
        yc-text-field(label="All of these words" v-model="textAll")
        .ma-2.text-xs.font-normal.primary400--text Example: Ismail Adam - contains "Ismail" or "Adam" or both
        yc-text-field.mt-4(label="This exact phrase" v-model="textExact")
        .ma-2.text-xs.font-normal.primary400--text Example: Ahmad Adam - contains the exact phrase "Ahmad Adam"
      template(v-if="filter.datatype === 'date'")
        div Filter {{ filter.name }}:
        yc-select.mt-4(v-model="dateCondition" :items="dateOptions")
        yc-text-field.mt-4(label="Date selection" v-model="selectedDate" disabled)
        v-card.mt-8(outlined)
          yc-date-picker(:parentDate.sync="selectedDate" :range="dateCondition === 'between'")
      template(v-if="filter.datatype === 'number'")
        .mb-4 Filter {{ filter.name }} with value:
        yc-select.mt-4(v-model="numberCondition" :items="numberOptions")
        yc-text-field.mt-4(:label="$t('enter_value')" v-model="selectedNumber" type="number")
</template>

<script>
import FilterDetailContainer from './FilterDetailContainer.vue'

export default {
  props: ['filter'],
  components: { FilterDetailContainer },
  data: () => ({
    textAll: '',
    textExact: '',
    selectedNumber: null,
    numberCondition: 'more',
    numberOptions: [
      { id: 'more', label: 'More than' },
      { id: 'less', label: 'Less than' },
      { id: 'equal', label: 'Equal to' }
    ],
    dateCondition: 'before',
    selectedDate: null,
    dateOptions: [
      { id: 'before', label: 'Before' },
      { id: 'after', label: 'After' },
      { id: 'exact', label: 'Exact date' }
    ],
  }),
  computed: {
    title() {
      return `Filter ${this.filter?.name || ''}`
    }
  },
  created() {
    const customData = this.filter.data
    if (customData) {
      const datatype = this.filter.datatype
      if (datatype === 'string') {
        const { icontains, iexact } = this.filter.data
        this.textAll = icontains || ''
        this.textExact = iexact || ''
      } else if (datatype === 'date') {
        const { before, after, exact } = this.filter.data
        if (before) {
          this.dateCondition = 'before'
          this.selectedDate = before
        }
        if (after) {
          this.dateCondition = 'after'
          this.selectedDate = after
        }
        if (exact) {
          this.dateCondition = 'exact'
          this.selectedDate = exact
        }
      } else if (datatype === 'number') {
        const { more, less, equal } = this.filter.data
        if (more) {
          this.numberCondition = 'more'
          this.selectedNumber = more
        }
        if (less) {
          this.numberCondition = 'less'
          this.selectedNumber = less
        }
        if (equal) {
          this.numberCondition = 'equal'
          this.selectedNumber = equal
        }
      }
    }
  },
  methods: {
    save() {
      let data = {}
      const type = this.filter.datatype
      if (type === 'string') {
        data = {
          icontains: this.textAll,
          iexact: this.textExact
        }
      }
      if (type === 'date') {
        data = this.getDateFilterData()
      }
      if (type === 'number') {
        data = this.getNumberFilterData()
      }
      this.$emit('onFiltered', { id: this.filter.id, data })
      this.back()
    },
    getNumberFilterData() {
      switch (this.numberCondition) {
        case 'more':
          return { gt: this.selectedNumber }
        case 'less':
          return { lt: this.selectedNumber }
        case 'equal':
          return { exact: this.selectedNumber }
        default:
          return {}
      }
    },
    getDateFilterData() {
      switch (this.dateCondition) {
        case 'before':
          return { before: this.selectedDate }
        case 'after':
          return { after: this.selectedDate }
        case 'exact':
          return { on: this.selectedDate }
        default:
          return {}
      }
    },
    back() {
      this.$emit('onBack')
    }
  }
}
</script>